<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>

  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Create" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    <unity-textbox-control displayName="Name" description="Enter the name of the city or town." [control]="formGroup.controls.name" />
    <unity-textbox-control
      displayName="Area"
      description="Specify the area in which this community is located."
      [control]="formGroup.controls.area_name" />
    <ng-content submit-options>
      <unity-action-cancel-shared [disabled]="false" [action]="returnToDashboardAction" />
    </ng-content>
  </unity-card-new-shared>
</unity-page-container>
